module.exports = __webpack_public_path__ + "media/partner_mo1.55372b31.webm";